import { PrimaryUnitParams } from './interfaces';
import { orderBy } from 'lodash';
import moment from 'moment';
import { DateRange } from '@ispm/shared/components/calendar-wrapper/DateRange';
interface RGBColor {
  r: number;
  g: number;
  b: number;
}

export class ChartUtils {

  public static getPrimaryUnit(data: PrimaryUnitParams[]): string | null {
    const unitGroups = data.reduce((acc, curr) => {
      if (acc.has(curr.unit)) {
        const unitGroup = acc.get(curr.unit);
        unitGroup.itemsNumber++;
        if (unitGroup.latestDate < curr.date) {
          unitGroup.latestDate = curr.date;
        }
      } else {
        acc.set(curr.unit, {
          itemsNumber: 1,
          latestDate: curr.date
        });
      }
      return acc;
    }, new Map<string, { itemsNumber: number, latestDate: string }>());

    if (unitGroups.size < 2) { return null; }

    const orderedUnitGroups = orderBy(
      Array.from(unitGroups).reverse(),
      [
        ([_, unitGroup]) => unitGroup.itemsNumber,
        ([_, unitGroup]) => unitGroup.latestDate
      ],
      [
        'desc',
        'desc'
      ]
    );

    return orderedUnitGroups[0] ? orderedUnitGroups[0][0] : null;
  }

  public static areSomeDatesInFocus(dates: { date?: string }[], focusDateRange: DateRange): boolean {
    if (!focusDateRange || !focusDateRange.min || !focusDateRange.max) {
      return true;
    }
    const min = moment(focusDateRange.min).unix();
    const max = moment(focusDateRange.max).unix();
    return dates.some(item => {
      const date = moment(item.date).unix();
      return (date >= min && date <= max);
    });
  }
  public static hexToRgb = (hex: string): RGBColor => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }

}
